/*
 *  (c) 2015 - 2021 ENISCO by FORCAM GmbH
 */
import {SvgIcon, SvgIconProps} from '@mui/material'
import React from 'react'

export function DefaultAppIcon(props: SvgIconProps) {
  return (
    <SvgIcon color={'primary'} {...props} viewBox='0 0 32 32'>
      <path d='M26,15V26H15V15H26m0-2H15a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V15a2,2,0,0,0-2-2Z' />
      <path d='M26,3H6A2.15,2.15,0,0,0,4,5V26a2.15,2.15,0,0,0,2,2h5V26H6V5H26v6h2V5a2.15,2.15,0,0,0-2-2Z' />
    </SvgIcon>
  )
}
